define(["exports", "styled-components", "../../atoms/DropdownBox"], function (_exports, _styledComponents, _DropdownBox) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Menu = _exports.Container = _exports.Button = void 0;
  _styledComponents = _interopRequireDefault(_styledComponents);

  var Container = _styledComponents.default.div.withConfig({
    displayName: "style__Container",
    componentId: "sc-vsidm3-0"
  })(["position:relative;@media (max-width:700px){order:-1;}"]);

  _exports.Container = Container;

  var Button = _styledComponents.default.button.withConfig({
    displayName: "style__Button",
    componentId: "sc-vsidm3-1"
  })(["appearance:none;background:none;border:0;height:29px;overflow:hidden;box-icon{fill:white;cursor:pointer;}"]);

  _exports.Button = Button;
  var Menu = (0, _styledComponents.default)(_DropdownBox.DropdownBox).withConfig({
    displayName: "style__Menu",
    componentId: "sc-vsidm3-2"
  })(["@media (max-width:700px){a{padding:8px 16px}}@media (min-width:700px){width:250px;&:before{right:27px}}"]);
  _exports.Menu = Menu;
});